import { render, staticRenderFns } from "./SleepManualImage.vue?vue&type=template&id=6d6801cc"
import script from "./SleepManualImage.vue?vue&type=script&lang=js"
export * from "./SleepManualImage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports